"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ExternalLinkContainer = (0, styled_1.default)('div') `
  ${(props) => props.template}
`;
const ExternalLink = ({ config, template }) => {
    const { external_link } = config.params;
    const { display_dictionary } = config;
    const pre_link_text = display_dictionary['external_link.pre_link_text'];
    const link_text = display_dictionary['external_link.link_text'];
    if (external_link)
        return (react_1.default.createElement(ExternalLinkContainer, { template: template, "data-ref": "external-link" },
            pre_link_text,
            react_1.default.createElement("a", { href: external_link, target: "_blank", rel: "noreferrer noopener" }, link_text)));
    return null;
};
exports.ExternalLink = ExternalLink;
//# sourceMappingURL=ExternalLink.js.map